
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import AgentLayout from "../components/AgentLayout";

const EditBetDelay = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = searchParams.get("id");

    const [value, setValue] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `http://localhost:5001/master/betdelay/event-limits/${id}`
                );

                setValue(response.data.data.value);
            } catch (error) {
                setMessage("Unable to fetch bet delay.");
            }
        };

        if (id) fetchData();
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!value || Number(value) < 0 || isNaN(Number(value))) {
            setMessage("Please enter a valid value.");
            return;
        }

        try {
            const response = await axios.put(
                `http://localhost:5001/master/betdelay/event-limits/${id}`,
                { value: Number(value) }
            );

            setMessage(response.data.message);
        } catch (error) {
            setMessage("Failed to update bet delay.");
        }
    };

    return (
        <AgentLayout>
            <div className="row">
                <div className="col-lg-12">
                    <div className="panel panel-default">
                        <div className="panel-heading">&nbsp;&nbsp;Edit Bet Delay</div>

                        <div className="panel-body" style={{ marginLeft: "10px" }}>
                            {message && <p>{message}</p>}

                            <form onSubmit={handleUpdate}>
                                <div className="form-group" style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                    <label htmlFor="value">Value</label>
                                    <input
                                        type="number"
                                        id="value"
                                        className="form-control"
                                        style={{ width: "30%" }}
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                        required
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary btn-sm">
                                    Update Bet Delay
                                </button>{" "}

                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={() => navigate("/betdelay")}
                                >
                                    Bet Delay List
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AgentLayout>
    );
};

export default EditBetDelay;
